module.exports = require('./helpers/bundle-url').getBundleURL('ex1cr') + "../styles/" + require('./helpers/bundle-manifest').resolve("a0Rqi");